import React, { useEffect, useState } from 'react';
import { Container, Typography, Card, CardContent, Table, TableHead, TableRow, TableCell, TableBody, Stack, Button, Box } from '@mui/material';
import reportApi from '../../api/reportApi';
import { useParams } from 'react-router-dom';
import BackButtonDesktop from '../../components/BackButtonDesktop';
import { formatDate } from '../../utils/dateFormatter';

export default function ReportContribuentePage() {
  const { id } = useParams();
  const [report, setReport] = useState(null);

  useEffect(() => {
    reportApi.get(id).then(r => setReport(r.data));
  }, [id]);

  if (!report) return <div>Loading...</div>;

  return (
    <Container sx={{ mb: 4 }}>
    <BackButtonDesktop />
      {/* HEADER STUDIO */}
      <Card sx={{ mt: 2, mb: 2, bgcolor: '#1E40AF', color: 'white' }}>
        <CardContent>
          <Typography variant="h5">{report.studioNome || "REPORT SITUAZIONE FISCALE"}</Typography>
          {report.studioIndirizzo && <Typography>{report.studioIndirizzo}</Typography>}
          {report.studioPIVA && <Typography>P.IVA: {report.studioPIVA}</Typography>}
          {report.studioEmail && <Typography>Email: {report.studioEmail}</Typography>}
          {report.studioTelefono && <Typography>Tel: {report.studioTelefono}</Typography>}
        </CardContent>
      </Card>

      {/* BOX CONTRIBUENTE */}
      <Card sx={{ mt: 2, mb: 2 }}>
        <CardContent>
          <Typography variant="h6">Contribuente</Typography>
          <Typography>{report.contribuenteNome}</Typography>
          <Typography>CF: {report.contribuenteCf}</Typography>
          <Typography>Data report: {formatDate(report.dataGenerazione)}</Typography>
        </CardContent>
      </Card>

      {/* RIEPILOGO */}
      <Card sx={{ mt: 2, mb: 2 }}>
        <CardContent>
          <Typography>Totale Debiti: € {report.totaleDebiti}</Typography>
          <Typography>Totale Crediti: € {report.totaleCrediti}</Typography>
          <Typography>Rate saltate: {report.rateSaltate}</Typography>
          <Typography variant="h6">Saldo: € {report.saldo}</Typography>
        </CardContent>
      </Card>

      {/* PULSANTI EXPORT */}
      <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
        <Button variant="contained" onClick={() => reportApi.pdf(id)}>Export PDF</Button>
        <Button variant="outlined" onClick={() => reportApi.excel(id)}>Export Excel</Button>
      </Stack>

      {/* DOCUMENTI */}
      {report.documenti.map(doc => (
        <Card key={doc.documentoId} sx={{ mt: 2 }}>
          <CardContent>
            <Typography variant="h6">{doc.tipo} - {doc.descrizione}</Typography>
            <Table size="small" sx={{ mt: 1 }}>
              <TableHead>
                <TableRow>
                  <TableCell>Data Scadenza</TableCell>
                  <TableCell>Tipo</TableCell>
                  <TableCell>Importo</TableCell>
                  <TableCell>Stato</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {doc.scadenze.map(s => (
                  <React.Fragment key={s.scadenzaId}>
                    <TableRow>
                      <TableCell>{formatDate(s.dataScadenza)}</TableCell>
                      <TableCell>{s.tipo}</TableCell>
                      <TableCell>€ {s.importo}</TableCell>
                      <TableCell>{s.stato}</TableCell>
                    </TableRow>
                    {s.tributi && s.tributi.length > 0 && (
                      <TableRow>
                        <TableCell colSpan={4}>
                          <Box sx={{ ml: 4 }}>
                            <Typography variant="subtitle2">Tributi</Typography>
                            <Table size="small">
                              <TableHead>
                                <TableRow>
                                  <TableCell>Codice Tributo</TableCell>
                                  <TableCell>Anno</TableCell>
                                  <TableCell>Debito</TableCell>
                                  <TableCell>Credito</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {s.tributi.map((t, idx) => (
                                  <TableRow key={idx}>
                                    <TableCell>{t.codiceTributo}</TableCell>
                                    <TableCell>{t.annoRiferimento}</TableCell>
                                    <TableCell>€ {t.importoDebito}</TableCell>
                                    <TableCell>€ {t.importoCredito}</TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </Box>
                        </TableCell>
                      </TableRow>
                    )}
                  </React.Fragment>
                ))}
              </TableBody>
            </Table>
          </CardContent>
        </Card>
      ))}
    </Container>
  );
}
